


















































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import BaseView from "@/components/BaseView.vue";
import { DataOptions } from "vuetify";
import { Pagination } from "@/store";
import { UserResource } from "@/store/user/types";

@Component({
  components: {
    BaseView
  }
})
export default class UserList extends Vue {
  readonly store = this.$store.direct;
  readonly title = "Usuarios";
  readonly subtitle = "Lista todos los usuarios creados en la plataforma";
  readonly info = null;

  get options() {
    return this.store.getters.options;
  }

  set options(val: DataOptions) {
    this.store.commit.SET_PAGINATION_FROM_DATA_OPTIONS(val);
  }

  get users() {
    return this.store.getters.user.users;
  }

  get pagination() {
    return this.store.state.pagination;
  }

  get totalItems() {
    return this.store.state.totalItems;
  }

  get loading() {
    return this.store.state.loading > 0;
  }

  get open() {
    return this.selected != "";
  }

  isMe(id: string) {
    return this.store.state.session.user
      ? this.store.state.session.user.id == id
      : false;
  }

  set open(val: boolean) {
    if (!val) this.selected = "";
  }

  openRemove(val: string) {
    this.selected = val;
  }

  selected: string = "";

  headers = [
    {
      text: "#",
      align: "left",
      sortable: false
    },
    {
      text: "Email",
      value: "email",
      align: "center"
    },
    {
      text: "Nombre",
      value: "full_name",
      align: "center"
    },
    {
      text: "RUT",
      value: "rut",
      align: "center"
    },
    {
      text: "Admin",
      value: "is_admin",
      align: "center"
    },
    {
      text: "Acciones",
      align: "center",
      sortable: false
    }
  ];

  async destroy(id: string) {
    let res = await this.store.dispatch.user.delete(id);
    if (res.error) {
      this.store.commit.PUSH_MESSAGE({
        message: "Ha ocurrido un error. Intente nuevamente.",
        type: "error"
      });
    } else {
      this.store.commit.PUSH_MESSAGE({
        message: "El usuario se ha eliminado correctamente.",
        type: "success"
      });
    }
    this.open = false;
  }

  detail(user: UserResource) {
    this.$router.push("/users/" + user.id);
  }

  refresh() {
    this.store.dispatch.user.get();
  }

  mounted() {
    this.refresh();
  }

  @Watch("pagination", { deep: true })
  handleOptionsChange(newVal: Pagination, oldVal: Pagination) {
    if (
      this.store.state.totalItems != undefined &&
      (newVal.page != oldVal.page ||
        newVal.itemsPerPage != oldVal.itemsPerPage ||
        newVal.sortBy != oldVal.sortBy ||
        newVal.sortDesc != oldVal.sortDesc)
    ) {
      this.store.dispatch.user.get();
    }
  }
}
